import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'
// import { response } from 'express'

export const getTaskOverview = async ({ project_id, token }) => {
  try {
    return await clientPublic
      .get(`project/taskoverview?project_id=${project_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const DOCUMENT_SUMMARY_REPORT = async ({ id, token }) => {
  try {
    return await clientPublic
      .get(`itemdocument/summary?project_id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const DATA_CHANG_PROJECT_FILE = async ({ params, token }) => {
  try {
    return await clientPublic
      .get(
        `itemdocument/show?project_id=${params.id_project}&sprintflow_id=${params.sprintflow_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const DATA_OVERDUE = async ({ params, token }) => {
  try {
    return await clientPublic
      .get(`project/taskoverdue?project_id=${params.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getTaskProgress = async ({ id, token }) => {
  try {
    return await clientPublic
      .get(`project/taskprogress?project_id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

// &sprintflow_id=39412
export const CALL_API_OVERDUE = async ({ project_id, token }) => {
  try {
    return await clientPublic
      .get(`project/taskoverdue?project_id=${project_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
